<mat-card>
    <mat-card-header>
      <mat-card-title>Find...</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-tab-group>
            <mat-tab label="Invoice"> 
                <div style="height:300px;width:95%;">
                <form 
                (ngSubmit)="onSubmitFindInvoice()" 
                novalidate
                [formGroup]="inoviceSearchForm" style="margin-top:20px;">
                    <div class="row margin-top:20px;">
                        <div class="col-12">
                            <mat-form-field appearance="fill" style="width:100%;">
                                <mat-label class="font-size-normal">Invoice Number</mat-label>
                                <input matInput placeholder="Invoice Number" autocomplete="chrome-off" formControlName="invoiceNumber" class="font-size-normal" >
                                <mat-error *ngIf="inoviceSearchForm.get('invoiceNumber')!.hasError('required')" class="font-size-normal">The Invoice Number is required</mat-error>
                                <mat-error *ngIf="inoviceSearchForm.get('invoiceNumber')!.hasError('maxlength')" class="font-size-normal">The maximum length cannot exceed 32 characters</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <button type="submit" class="btn btn-primary mt-3" style="margin-left:0px;" [disabled]="!inoviceSearchForm.valid">Find Invoice</button>
                        </div> 
                    </div>
                </form>
           
                <ng-container *ngIf="invoiceNumberFound ===''">
                    <!-- <span>No Invoice Located</span> -->
                </ng-container>

                <ng-container *ngIf="invoiceNumberFound !==''">
                    <div style="margin-top:20px;">
                        <span>Invoice Found for Lot 3250 - City Center Bellevue </span>
                    </div>
                    <div class="row" style="margin-top:20px;">
                        <div class="col-4">
                            <!-- <a href="https://dev.acepark.net/Invoice/ReturnPdf/1004/GB01004112410085" target=”_blank”>View Invoice</a> -->
                            <span style="color:black;" class="mimic-button-hover" (click)="onNavToViewInvoice()">View Invoice</span>
                            <span class="material-icons mimic-button-hover" style="color:black;margin-left:10px;position:relative;top:7px;" (click)="onNavToViewInvoice()">
                                monetization_on
                            </span>
                        </div>
                        <div class="col-4">
                            <!-- <a href="#" target=”_blank”>Enable Screen</a> -->
                            <span style="color:black;" class="mimic-button-hover" (click)="onNavToViewInvoice()">Enable Screen</span>
                            <span class="material-icons mimic-button-hover" style="color:black;margin-left:10px;position:relative;top:7px;" (click)="onNavToViewInvoice()">
                                summarize
                            </span>
                        </div>
                    </div>
                </ng-container>
            </div>
            
            </mat-tab>
            


            
            
            <mat-tab label="Parker">
                
                <div style="height:300px;width:95%;">
                    <form 
                    (ngSubmit)="onSubmitFindParker()" 
                    novalidate
                    [formGroup]="parkerSearchForm" style="margin-top:20px;">
                        <div class="row margin-top:20px;">
                            <div class="col-6">
                                <mat-form-field appearance="fill" style="width:100%;">
                                    <mat-label class="font-size-normal">Last Name</mat-label>
                                    <input matInput placeholder="Last Name" autocomplete="chrome-off" formControlName="lastName" class="font-size-normal" >
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="fill" style="width:100%;">
                                    <mat-label class="font-size-normal">First Name</mat-label>
                                    <input matInput placeholder="First Name" autocomplete="chrome-off" formControlName="firstName" class="font-size-normal" >
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <button type="submit" class="btn btn-primary mt-3" style="margin-left:0px;" [disabled]="!parkerSearchForm.valid">Find Parker(s)</button>
                            </div> 
                        </div>
                    </form>

                    </div>
            
            </mat-tab>






            <mat-tab label="Company">
                
                <div style="height:300px;width:95%;">
                    <form 
                    (ngSubmit)="onSubmitFindCompany()" 
                    novalidate
                    [formGroup]="companySearchForm" style="margin-top:20px;">
                        <div class="row margin-top:20px;">
                            <div class="col-12">
                                <mat-form-field appearance="fill" style="width:100%;">
                                    <mat-label class="font-size-normal">Company Name</mat-label>
                                    <input matInput placeholder="Company Name" autocomplete="chrome-off" formControlName="companyName" class="font-size-normal" >
                                </mat-form-field>
                            </div>
                           
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <button type="submit" class="btn btn-primary mt-3" style="margin-left:0px;" [disabled]="!companySearchForm.valid">Find Company(s)</button>
                            </div> 
                        </div>
                    </form>

                    </div>
            
            </mat-tab>
         
        
        
        </mat-tab-group>
        
    </mat-card-content>
  </mat-card>
